<script setup lang="ts">
import PdsButton from '@/components/pds/PdsButton.vue';
import PdsModal from '@/components/pds/PdsModal.vue';
import { computed } from 'vue';
import { formatDate, formatMoney, formatTime } from '../format';
import type { PdsOrder } from '../types';

const props = defineProps<{ order: PdsOrder }>();
const emit = defineEmits<{ acknowledge: [] }>();

const prepared = computed(() => props.order.items.filter((i) => i.prepared));
const pickup = computed(
  () =>
    `retrait ${formatDate(props.order.dueAt).toLowerCase()} · ${formatTime(props.order.dueAt)}`,
);
</script>

<template>
  <PdsModal size="md" :dismissible="false">
    <template #title>Commande annulée</template>
    <template #subtitle>
      #{{ order.number }} · {{ order.label }} · {{ pickup }}
    </template>

    <div class="flex flex-col gap-5 px-5 py-[25px]">
      <div class="bg-creux flex flex-col gap-1 rounded-[16px] px-4 py-[17px]">
        <p class="text-[16px] leading-[1.3] font-bold">
          Le client a annulé à
          {{ formatTime(order.cancelledAt ?? order.dueAt) }}, depuis sa page de
          commande.
        </p>
        <p class="text-encre-douce text-[12px] leading-[1.45]">
          Le remboursement de {{ formatMoney(order.totalPaidCents) }} est
          automatique. Rien ne vous est demandé pour cela.
        </p>
      </div>

      <section v-if="prepared.length" class="bg-creux rounded-[24px]">
        <h3
          class="text-encre-douce px-[13px] py-2 text-[12px] leading-[14px] font-semibold tracking-[0.9px] uppercase"
        >
          Vous en aviez préparé {{ prepared.length }} sur
          {{ order.items.length }}
        </h3>
        <div
          class="bg-carte border-filet-doux flex flex-col rounded-[24px] border px-[14px] pt-[10px] pb-[12px]"
        >
          <p
            v-for="item in prepared"
            :key="item.id"
            class="flex h-7 items-center gap-3 text-[14px] leading-[1.4]"
          >
            <span class="w-[30px] shrink-0 text-right font-semibold">
              {{ item.quantity }}<span class="text-[12px] font-normal">×</span>
            </span>
            {{ item.name }}
          </p>
          <p class="text-encre-douce pt-1 text-[12px] leading-[1.45]">
            Le PDS ne dit pas quoi en faire : remise en stock ou perte se
            décident au comptoir.
          </p>
        </div>
      </section>
    </div>

    <template #footer>
      <span class="hidden flex-1 sm:block"></span>
      <PdsButton fit @click="emit('acknowledge')">Retour au tableau</PdsButton>
    </template>
  </PdsModal>
</template>
